import { createSlice } from "@reduxjs/toolkit";
import { ExportReportFormat } from "./Types";

type initialStateType = {
  reportFormatsList: {
    ID: number;
    saved_export_format: string;
    selected_options: ExportReportFormat;
  }[];
  status: {
    partnersReportLoading: boolean;
    reportFormatsListLoading: boolean;
    saveReportFormatLoading: boolean;
    deleteReportFormatLoading: boolean;
  };
};

var initialState: initialStateType = {
  reportFormatsList: [],
  status: {
    partnersReportLoading: false,
    reportFormatsListLoading: false,
    saveReportFormatLoading: false,
    deleteReportFormatLoading: false,
  },
};

const reportsSlice = createSlice({
  name: "reports",
  initialState: initialState,
  reducers: {
    setPartnersReportLoading: (state, action) => {
      state.status.partnersReportLoading = action.payload;
    },
    setReportFormatsList: (state, action) => {
      state.reportFormatsList = action.payload;
    },
    setReportFormatsListLoading: (state, action) => {
      state.status.reportFormatsListLoading = action.payload;
    },
    setSaveReportFormatLoading: (state, action) => {
      state.status.saveReportFormatLoading = action.payload;
    },
    setDeleteReportFormatLoading: (state, action) => {
      state.status.deleteReportFormatLoading = action.payload;
    },
  },
});

export const reportsSliceReducer = reportsSlice.reducer;
export const reportsSliceAction = reportsSlice.actions;
